import React from 'react';
import { Button } from 'reactstrap';

//Components
import TabelaListagem from '../../../../../components/TabelaListagem/TabelaListagem';

//Helpers
import { showMessage } from '../../../../../helpers/message';

//API
import infracoes_api from '../../../../../api/infracoes_api';

//Context
import { useAuth } from '../../../../../context/auth';

export default function TabelaRecalculoInfracoes({ infracoesRecalculadas, indiceRecalculo, loadInfracoes, setInfracoesRecalculadas, setOpenRecalculoModal }) {
    const { setLoading } = useAuth();

    const salvarRecalculo = async () => {
        setLoading(true);
        try {
            await infracoes_api.RecalcularInfracoes({
                infracao_Ids: infracoesRecalculadas.map(i => i.id),
                indice: parseFloat(indiceRecalculo.replace(",", "."))
            });

            showMessage("Aviso", "Infrações recalculadas com sucesso", "success", () => {
                setInfracoesRecalculadas([]);
                setOpenRecalculoModal(false);
                loadInfracoes();
            });
        } catch (err) {
            showMessage("Erro", err?.message ?? "Erro ao recalcular", "error", null);
        } finally {
            setLoading(false);
        }
    };

    const cancelarRecalculo = () => setInfracoesRecalculadas([]);

    return (
        <>
            <div className="d-flex justify-content-end mb-2">
                <Button color="success" onClick={salvarRecalculo}>Salvar</Button>
                <Button color="secondary" className="ms-2" onClick={cancelarRecalculo}>Cancelar</Button>
            </div>

            <TabelaListagem
                title={<h5 >Infrações Recalculadas <span className='text-danger'>(Índice {indiceRecalculo})</span></h5>}
                headers={[
                    { value: "Identificação", objectValue: "identificacao" },
                    { value: "Valor Original", objectValue: "valor" },
                    { value: "Valor Atualizado", objectValue: "valorAtualizado" }
                ]}
                items={infracoesRecalculadas}
            />
        </>
    );
}
